import { render, staticRenderFns } from "./BundleBulkIndividualItem.vue?vue&type=template&id=630c45b5&scoped=true&lang=pug&"
import script from "./BundleBulkIndividualItem.vue?vue&type=script&lang=js&"
export * from "./BundleBulkIndividualItem.vue?vue&type=script&lang=js&"
import style0 from "./BundleBulkIndividualItem.vue?vue&type=style&index=0&id=630c45b5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "630c45b5",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VForm } from 'vuetify/lib/components/VForm';
import { VImg } from 'vuetify/lib/components/VImg';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VCard,VCol,VDivider,VForm,VImg,VRow,VTextField})
